export default "__VITE_ASSET__BBx5wPsE__"